<script setup lang="ts">
import { CardAdmin } from '@shared/ui/cards'

import HelpersGrid from './HelpersGrid.vue'
import HelperActionRow from './HelperActionRow.vue'
import HelperDateRangeCard from './HelperDateRangeCard.vue'
import HelperTcrBonusCard from './HelperTcrBonusCard.vue'

defineOptions({
  name: 'HelpersTutorsPage',
})
</script>

<template>
  <HelpersGrid>
    <CardAdmin
      title="Tutor"
      fullwidth
    >
      <HelperActionRow
        label="Calculate attendance rate"
        route-name="admin.helpers.tutor.calculate-attendance-rate"
      />
      <HelperActionRow
        label="Calculate conversion rate"
        route-name="admin.helpers.tutor.calculate-conversion-rate"
      />
      <HelperActionRow
        label="Calculate S-TAR (student attendance rate)"
        route-name="admin.helpers.tutor.calculate-student-attendance-rate"
      />
    </CardAdmin>
    <HelperTcrBonusCard />
    <HelperDateRangeCard
      title="Cancel tutor slots for interval"
      route-name="admin.helpers.tutor-slots.cancel-for-interval"
    />
  </HelpersGrid>
</template>
